import React, { PropsWithChildren } from 'react';
import { useColorModeValue, LinkProps, forwardRef } from '@chakra-ui/react';
import { Colors } from 'src/shared';
import LinkButton from './LinkButton';

export interface PrimaryLinkProps extends PropsWithChildren<LinkProps> {
  to: string;
  isActive?: boolean;
}

const PrimaryLink = forwardRef((props: PrimaryLinkProps, ref) => {
  const { to, children, isActive = false, ...remainingProps } = props;

  const defaultBg = useColorModeValue(Colors.light.secondaryBg, Colors.dark.secondaryBg);
  const activeBg = useColorModeValue(Colors.light.primary, Colors.dark.primary);
  const color = useColorModeValue(Colors.light.whiteText, Colors.dark.whiteText);

  const bg = isActive ? activeBg : defaultBg;

  return (
    <LinkButton ref={ref} color={color} bg={bg} to={to} rounded={'full'} {...remainingProps}>
      {children}
    </LinkButton>
  );
});

export default PrimaryLink;
